














































import { defineComponent, computed } from '@vue/composition-api'
import { useUnsavedWarning } from '@/composables/useUnsavedWarning'
import { useQuery, useResult, useMutation } from '@vue/apollo-composable'
import updateEmailMutation from '@/lib/graphql/updateEmailTemplate.mutation.gql'
import emailTemplateQuery from '@/lib/graphql/emailTemplate.query.gql'
import { useRouter } from '@u3u/vue-hooks'
import { useUpdater } from '@/composables/useUpdater'

export default defineComponent({
  setup(_, { root }) {
    const { route } = useRouter()
    const params = computed(() => ({
      id: route.value.params.id
    }))

    const { result, loading, onError } = useQuery(emailTemplateQuery, params)
    const data = useResult(result)
    onError(error => {
      console.error(error)
      root?.$message.error('Something went wrong')
    })

    const { markAsDirty, resetDirty, isDirty } = useUnsavedWarning()
    const {
      updateBag,
      onChange,
      modelProps: {
        title,
        html_content: htmlContent,
        text_content: textContent
      }
      // eslint-disable-next-line
      // @ts-ignore
    } = useUpdater(data, ['title', 'html_content', 'text_content'])

    onChange(isEqual => {
      if (isEqual) {
        resetDirty()
      } else {
        markAsDirty()
      }
    })

    const {
      mutate,
      loading: isSaving,
      onError: onMutError,
      onDone
    } = useMutation(updateEmailMutation, () => ({
      variables: {
        id: params.value.id,
        set: updateBag
      },
      // eslint-disable-next-line
      update: (cache: any, newData: any) => {
        // eslint-disable-next-line
        const data: any = cache.readQuery({
          query: emailTemplateQuery,
          variables: { id: params.value.id }
        })

        Object.keys(updateBag)
          .filter(k => typeof updateBag[k] !== 'undefined')
          .forEach(k => {
            data.email_templates_by_pk[k] = updateBag[k]
          })

        cache.writeQuery({
          query: emailTemplateQuery,
          // eslint-disable-next-line
          data,
          variables: { id: params.value.id }
        })
      }
    }))

    const submit = () => {
      mutate()
    }

    onDone(() => {
      resetDirty()
    })

    // eslint-disable-next-line
    onMutError((err: any) => {
      console.error(err)
      root?.$message.error('Something went wrong')
    })

    return {
      isDirty,

      loading,

      submit,
      isSaving,

      data,
      title,
      textContent,
      htmlContent
    }
  }
})
